import { PaymentFilter, PayGroup } from "../types";
import { PaymentListData, GetPaymentParamsKlijenti } from "../types";
import { User } from "../../../auth/types";
import { webApiWithResponse } from "../../../../core/http/httpThunks";
import { getParamsDateString } from "../../../../core/util/functions";

const getPaymentsWebApi = (
  user: User,
  page: number,
  itemsPerPage: number,
  filter: PaymentFilter
) => {
  const params: GetPaymentParamsKlijenti = {
    userid: user.userId,
    inout: filter.inout,
    fromrow: page * itemsPerPage,
    numofrows: itemsPerPage,
    cliid: filter?.client?.cliId,
    nondedicated: filter.nondedicated,
    datefrom: getParamsDateString(filter.datefrom),
    dateto: getParamsDateString(filter.dateto),
    tranid: filter?.tranId,
  };

  return webApiWithResponse<PaymentListData[]>({
    method: "GET",
    url: "clearing/getpaymentlist",
    params,
  });
};

export default getPaymentsWebApi;
